import CourseContentLayoutStudent from "./CourseContentLayoutStudent";

function SeniorCourse(props) {
  return <CourseContentLayoutStudent {...props} totalModules={6} />;
}

export default SeniorCourse;